import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { MarketdateComponent } from './marketdate.component';
import { MarketdateDetailComponent } from './marketdate-detail.component';
import { MarketdatePopupComponent } from './marketdate-dialog.component';
import { MarketdateDeletePopupComponent } from './marketdate-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class MarketdateResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const marketdateRoute: Routes = [
  {
    path: 'marketdate',
    component: MarketdateComponent,
    resolve: {
      'pagingParams': MarketdateResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdate.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'marketdate/:id',
    component: MarketdateDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdate.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const marketdatePopupRoute: Routes = [
  {
    path: 'marketdate-new',
    component: MarketdatePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdate.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate/:id/edit',
    component: MarketdatePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdate.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate/:id/delete',
    component: MarketdateDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdate.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate/marketdate.route.ts